import { RadioPelican } from './component';

export * from './component';
export default RadioPelican;
